import React from 'react'
import _get from 'lodash/get'
import _set from 'lodash/set'
import _map from 'lodash/map'
import Select from 'react-select'
import Modal from 'react-modal'
import { withFormik } from 'formik'
import { withRouter } from 'react-router-dom'

import Field from '../../_library/Field'
import Button from '../../_library/Button'
import RichTextArea from '../../_library/RichTextArea'
import modalStyle from '../../../_common/core/modalStyle'
import { ENV } from '../../constants/env'
import Card from '../../_library/Card'
import { getTableColumns } from '../../utils/sortableTableUtils'
import { showAxiosError } from '../../utils/messenger'
import SortableTable from '../../_library/SortableTable'

function validateForm(data) {
  const errors = {}

  if (!_get(data, 'subject')) {
    _set(errors, 'subject', 'Required')
  }

  if (!_get(data, 'body')) {
    _set(errors, 'body', 'Required')
  }

  if (!_get(data, 'maxQuantity')) {
    _set(errors, 'body', 'Required')
  }

  if (!_get(data, 'maxUses')) {
    _set(errors, 'body', 'Required')
  }

  return errors
}

@withRouter
class EventLinkInvitationFormComponent extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      emailTemplatesModalOpen: false,
      sortBy: { column: 'created_at', asc: false },
    }

    this.editorRef = React.createRef()

    this.tableColumns = getTableColumns([
      { key: 'description', label: 'Description', sort: this.columnSortBy },
      { key: 'maxUses', label: 'Max. Uses', sort: this.columnSortBy },
      { key: 'maxQuantity', label: 'Max. Quantity', sort: this.columnSortBy },
      { key: 'link', label: 'Link', sort: this.columnSortBy },
      { key: 'created_at', label: 'Created at', sort: this.columnSortBy },
    ])
  }

  columnSortBy = column => {
    const { sortBy } = this.state
    this.setState({ sortBy: { column: column.key, asc: !sortBy.asc } })
  }

  openEmailTemplatesModal = () => {
    this.setState({
      emailTemplatesModalOpen: true,
    })
  }

  closeEmailTemplatesModal() {
    this.setState({
      emailTemplatesModalOpen: false,
    })
  }

  selectEmailTemplate = template => () => {
    this.props.setFieldValue('subject', template.subject)
    if (template.body) {
      this.editorRef.current?.setContent(template.body)
    } else if (template.preview_url) {
      $.get(template.preview_url, result => {
        this.editorRef.current?.setContent(result)
      })
    }
    this.setState({
      emailTemplatesModalOpen: false,
    })
  }

  changeMaxQuantity = e => {
    this.props.setFieldValue('maxQuantity', e.target.value)
    this.props.setFieldValue('maxUses', e.target.value)
  }

  changeMaxUses = e => {
    const {
      values: { maxQuantity },
    } = this.props
    const maxUses = e.target.value
    if (Number(maxUses) > Number(maxQuantity)) {
      this.props.setFieldValue('maxQuantity', e.target.value)
      this.props.setFieldValue('maxUses', e.target.value)
    } else {
      this.props.setFieldValue('maxUses', e.target.value)
    }
  }

  onTicketTypeChange = types => {
    this.props.setFieldValue(
      'ticketTypes',
      _map(types, t => t.value),
    )
  }

  onHoldTicketTypeChange = types => {
    this.props.setFieldValue(
      'ticketHoldIds',
      _map(types, t => t.value),
    )
  }

  onBodyChange = content => {
    this.props.setFieldValue('body', content)
  }

  render() {
    const {
      values,
      touched,
      errors,
      isSubmitting,
      handleChange,
      handleBlur,
      handleSubmit,
      submitLabel,
      event,
      tickets,
      emailTemplates,
      cardsStatus,
      history: { replace },
      isValid,
      invitations,
    } = this.props

    const { emailTemplatesModalOpen, sortBy } = this.state

    const ticketsHidden = tickets.filter(ticket => ticket.flagHidden)
    const ticketsHiddenOptions = _map(ticketsHidden, t => ({ value: t.id, label: t.displayName }))

    const filteredData = invitations.sort((a, b) =>
      sortBy.asc
        ? String(b[sortBy.column] || '').localeCompare(String(a[sortBy.column] || ''))
        : String(a[sortBy.column] || '').localeCompare(String(b[sortBy.column] || '')),
    )

    const holdTickets = tickets.reduce((curr, next) => {
      if (next.ticketHolds) {
        return curr.concat(
          next.ticketHolds.map(ticketHolds => ({
            value: ticketHolds.id,
            label: `${next.displayName} - ${ticketHolds.description}`,
          })),
        )
      }
      return curr
    }, [])

    return (
      <form ref="form" method="POST" onSubmit={handleSubmit}>
        <Card icon={'fa-envelope'} title={'Message'} status={cardsStatus && cardsStatus.message}>
          <div className="row">
            <div className="col-xs-12 text-right">
              <div aria-hidden className="btn btn-success btn-shadow" onClick={this.openEmailTemplatesModal}>
                Select from Email Templates
              </div>
            </div>
            <div className="col-xs-12">
              <Field
                id="subject"
                label="Subject"
                value={values.subject}
                error={errors.subject}
                touched={touched.subject}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
            <div className="col-xs-12">
              <Field
                id="description"
                label="Description"
                value={values.description}
                error={errors.description}
                touched={touched.description}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
            <div className="col-xs-12">
              <label className="control-label">
                <span>Invitation Content</span>
              </label>
              <RichTextArea
                ref={this.editorRef}
                id="body"
                baseurl={ENV.CDN_URL}
                value={values.body}
                error={errors.body}
                touched={touched.body}
                onChange={this.onBodyChange}
                onBlur={handleBlur}
              />
            </div>
            <div className="col-xs-12">
              <label className="control-label">
                <span>Unlock Registration for Hidden Ticket Type (optional)</span>
              </label>
              <Select
                id="hidden-ticket-type"
                multi={true}
                value={values.ticketTypes}
                options={ticketsHiddenOptions}
                onChange={this.onTicketTypeChange}
              />
            </div>
            <div className="div-spacing-10" />
            <div className="col-xs-12">
              <label className="control-label">
                <span>Hold Tickets (optional)</span>
              </label>
              <Select
                id="hold-ticket-type"
                multi={true}
                value={values.ticketHoldIds}
                options={holdTickets}
                onChange={this.onHoldTicketTypeChange}
              />
            </div>
            <div className="col-sm-6 col-xs-12">
              <div className="form-group">
                <label htmlFor="maxQuantity" className="number-dropdown-label">
                  Maximum number of tickets
                </label>
                <select
                  id="maxQuantity"
                  className="form-control"
                  value={values.maxQuantity}
                  onChange={this.changeMaxQuantity}
                >
                  {_map(new Array(50), (e, i) => (
                    <option key={50 - i} value={50 - i}>
                      {50 - i}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-sm-6 col-xs-12">
              <div className="form-group">
                <label htmlFor="maxUses" className="number-dropdown-label">
                  Maximum number of transactions
                </label>
                <select
                  id="maxUses"
                  className="form-control"
                  value={values.maxUses}
                  onChange={this.changeMaxUses}
                >
                  {_map(new Array(50), (e, i) => (
                    <option key={50 - i} value={50 - i}>
                      {50 - i}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-xs-12">
              <SortableTable
                sortBy={sortBy}
                data={filteredData}
                tableColumns={this.tableColumns}
                enableSort={true}
                actions={[
                  {
                    label: 'Copy Link',
                    className: 'btn btn-primary',
                    icon: 'fa fa-clipboard',
                    onClick: async data => {
                      try {
                        await navigator.clipboard.writeText(data.link)
                      } catch {
                        showAxiosError(
                          {},
                          'We do not have permissions to copy to clipboard. Please grant us permission.',
                        )
                      }
                    },
                  },
                ]}
                enableCopyTable={true}
                disableMobileView={true}
              />
            </div>
          </div>
        </Card>
        <div className="row text-center">
          <Button
            className="btn btn-success btn-lg btn-shadow btn-send"
            type="submit"
            disabled={isSubmitting || !isValid}
            loading={isSubmitting}
          >
            {submitLabel || (
              <span>
                <i className="fa fa-paper-plane" aria-hidden="true" /> Create{' '}
              </span>
            )}
          </Button>
        </div>
        <Modal
          className="modal-dialog modal-trans"
          style={modalStyle}
          isOpen={!!emailTemplatesModalOpen}
          contentLabel="Modal"
          onRequestClose={this.closeEmailTemplatesModal}
          closeTimeoutMS={150}
          ariaHideApp={false}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div>
                <div className="modal-header">
                  <p className="h4 text-compact">Select Email Template</p>
                </div>
                <div className="modal-body">
                  <div className="emailtemplates-table-container">
                    <div className="email-template-containter">
                      <div className="email-tempalate-title clearfix">
                        <span className="template-left-side">Details</span>
                        <span className="template-right-side mobile-template-action">Action</span>
                      </div>
                      <div className="email-template-content">
                        {emailTemplates &&
                          emailTemplates.map((template, index) => (
                            <div key={index} className="clearfix">
                              {template.enabled === 1 && (
                                <div className="template-list">
                                  <div className="template-left-side">
                                    <div>
                                      <b className="template-subtitle">Name:</b>
                                      {template.name}
                                    </div>
                                    <div>
                                      <b className="template-subtitle">Subject:</b>
                                      {template.subject}
                                    </div>
                                    <div>
                                      <b className="template-subtitle">Description:</b>
                                      {template.description}
                                    </div>
                                  </div>
                                  <div className="template-right-side clearfix">
                                    <span
                                      aria-hidden
                                      className="btn btn-primary btn-shadow select-template-btn"
                                      onClick={this.selectEmailTemplate(template)}
                                    >
                                      Select
                                    </span>
                                  </div>
                                </div>
                              )}
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <div className="btn-toolbar btn-toolbar-right">
                    <Button
                      className="btn btn-success btn-shadow"
                      type="button"
                      onClick={() => replace(`/event/${event.id}/email-templates`)}
                    >
                      Add New Template
                    </Button>
                    <Button className="btn btn-default" type="button" onClick={this.closeEmailTemplatesModal}>
                      Cancel
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </form>
    )
  }
}

const EventLinkInvitationForm = withFormik({
  mapPropsToValues: () => ({
    subject: '',
    body: '',
    ticketTypes: [],
    maxQuantity: 1,
    maxUses: 1,
    description: '',
    ticketHoldIds: [],
  }),

  validate: values => validateForm(values),

  handleSubmit: (values, { props, setSubmitting, resetForm }) => {
    props
      .onSubmit({
        ...values,
      })
      .then(() => {
        setSubmitting(false)
        resetForm()
      })
      .catch(() => {
        setSubmitting(false)
      })
  },
  displayName: 'EventInvitationForm',
})(EventLinkInvitationFormComponent)

export default EventLinkInvitationForm
